import React, { FC } from 'react';

const LeftPanel: FC = () => (
  <div
    className='flex flex-col w-full md:h-2/5 lg:h-full lg:w-1/2 p-10 items-center justify-center rounded-tr-3xl rounded-br-3xl'
    style={{
      background:
        'radial-gradient(120% 90% at 20% 15%, rgba(0,230,223,0.18) 0%, transparent 55%),' +
        'radial-gradient(120% 90% at 85% 85%, rgba(255,0,80,0.20) 0%, transparent 55%),' +
        'linear-gradient(180deg, #0E1130 0%, #050816 100%)',
    }}
  >
    <img
      src='/assets/funizzle-logo-zip-file/Logo.svg'
      alt='BingePlay'
      className='w-[172px] lg:w-[192px] xl:w-[192px] h-auto'
    />
    <h2 className='mt-2 text-3xl font-extrabold tracking-tight text-white'>
      BingePlay
    </h2>
    <p className='mt-2 text-sm tracking-wide text-white/70'>
      The TikTok for games.
    </p>
  </div>
);

export default LeftPanel;
